export default __webpack_public_path__ + "exclamation-mark-circle.8843659fea7c9e4d.svg";